import React, {useState, useEffect} from "react";
import Main from "../../components/template/Main";
import JoditEditor from "jodit-react";
import {FiX,FiCheck} from 'react-icons/fi';
import { useParams} from "react-router-dom";
import {get, put} from '../../store/config/register';
import addNotification from 'react-push-notification';
import { parse,format } from "date-fns"; 
import { login_Id } from "../../store/config/dadosuser";
import { isAdmin } from "../../store/config/auth";
import TableFooter from "../../components/table/TableFooter";
import useTable from "../../components/table/useTable";
import './Avisos.css'
import { Check } from "react-bootstrap-icons";

const headerProps = {
    icon: 'comments',
    title: 'Visualizar Mensagem'
  }

  const copyStringToClipboard = function(str) {
    var el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style = { position: "absolute", left: "-9999px" };
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  };
  
  const facilityMergeFields = [
    "FacilityNumber",
    "FacilityName",
    "Address",
    "MapCategory",
    "Latitude",
    "Longitude",
    "ReceivingPlant",
    "TrunkLine",
    "SiteElevation"
  ];
  const inspectionMergeFields = [
    "InspectionCompleteDate",
    "InspectionEventType"
  ];
  const createOptionGroupElement = (mergeFields, optionGrouplabel) => {
    let optionGroupElement = document.createElement("optgroup");
    optionGroupElement.setAttribute("label", optionGrouplabel);
    for (let index = 0; index < mergeFields.length; index++) {
      let optionElement = document.createElement("option");
      optionElement.setAttribute("class", "merge-field-select-option");
      optionElement.setAttribute("value", mergeFields[index]);
      optionElement.text = mergeFields[index];
      optionGroupElement.appendChild(optionElement);
    }
    return optionGroupElement;
  }
  const buttons = [
   
  ];

  const editorConfig = {
    readonly: false,
    toolbar: true,
    spellcheck: true,
    language: "pt_br",
    toolbarButtonSize: "medium",
    toolbarAdaptive: false,
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    //defaultActionOnPaste: "insert_clear_html",
    buttons: buttons,
    uploader: {
      insertImageAsBase64URI: true
    },
    width: 800,
    height: 440
  };

  const initialState = {
    aviso: {
      id: 0,
      titulo: '',
      login_Nome: '',
      messagem: '',
      data: ''
    }
  }

export default function VisualizarAviso() {
    const [data,setData] = useState('');
    const [aviso, setAviso] = useState(initialState.aviso);
    const [progresso, setProgresso] = useState({});
    const [destinatarios,setDestinatarios] =useState([]);
    const [page, setPage] = useState(1);
    const { slice, range } = useTable(destinatarios, page, 10);
    const {id} = useParams();

    useEffect(() => {
       buscaMensagem();
       
       
    },[aviso])

    useEffect(()=>{
      AtualizaLido();
      BuscaTotal();
      BuscaDestinatario();
    },[])

    async function BuscaTotal() {
    let tot =  await get('/AvisoPessoa/v1/Total/'+id);
        if(tot !== undefined){
          setProgresso(tot);      
        }
    }

    async function BuscaDestinatario() {
      let tot =  await get('/AvisoPessoa/v1/Destinatario/'+id);
          if(tot !== undefined){
            setDestinatarios(tot);      
          }
      }

    async function AtualizaLido() {
      let data = {aviso_Id: parseInt(id),login_Id: login_Id, lido: true}
      await put('/AvisoPessoa/v1/'+id,data)
    }

    function updateField(e){
        let avi = {...aviso};
        avi[e.target.name] =e.target.value;
        setAviso({...avi})
    }

    function notificacao() {
      let data ={ aviso_id: id, titulo: aviso.titulo, messagem: aviso.messagem, url: window.location.href}

      console.log(data)
        addNotification({
            title: data.titulo,
            subtitle: 'This is a subtitle',
            message: data.messagem,
            theme: 'darkblue',
            native: true // when using native, your OS will handle theming.
        });
    }

    async function buscaMensagem(){
        let avi = await get('/Aviso/v1/'+id);
        if(avi !== undefined){
          setData(avi.messagem)
          setAviso({...avi});
        }
    }

    function renderTable() {
        return (
          <div className='tabela'>
          <hr/>
          <table>
             <thead>
                 <tr>
                     <th scope="col">Morador</th>
                     <th scope="col">Unidade</th>
                     <th scope="col">Lido</th>
                    </tr>
             </thead>
             <tbody>
                 {slice === undefined ? null : slice.map((item, index) => {
                     return(
                         <tr key={index}>
                             <td data-label="Morador">{item.nome}</td>
                             <td data-label="Unidade">{item.unidade}</td>
                             <td data-label="Lido">{item.lido  == true ? ( 
                             <button className="action" style={{backgroundColor: '#228B22' }}>
                                            <FiCheck color="#FFF" size={17} />
                                        </button>) :
                                        ( 
                                        <button className="action" style={{backgroundColor: '#C0C0C0' }}>
                                            <FiX color="#FFF" size={17} />
                                        </button>
                                        ) 
                                        }</td>                              
                         </tr>
                     );
                 })}
             </tbody>
          </table>
          <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
     </div>
        );
    }

    function renderForm() {
        return (
            <div className="cadAvisoVisualiza">
              {isAdmin()  && (
                <div>
                  <label>{`Visualização: ${progresso.lido}/${progresso.total}`}</label>
                     <br />
                     <progress id="file" value={progresso.lido} max={progresso.total}> {progresso.lido} </progress>
                </div>                  
              )}

           <div className="box">
           <div className="box2">
           <label>Emitente:</label>
           </div>
           <div className="box3">
                <label>{aviso.login_Nome}</label>
           </div>
          
            </div>

            <div className="box">
            <div className="box2">
           <label>Data:</label>
           </div>
           <div className="box3">
           <label>{aviso.data === '' ? '' : format(parse(aviso.data,"yyyy-MM-dd'T'HH:mm:ss",new Date()),'dd/MM/yyyy')}</label>
           </div>
            </div>
                <div className="box">
                <div className="box2">
                  <label>Assunto:</label>
                  </div>
                  <div className="box3">
                  <label>{aviso.titulo}</label>
                  </div>
                </div>

                <div className="col-12 fieldEditor"> 
                  <JoditEditor
                    value={data}
                    config={editorConfig}
                    onChange={value => {
                      setData(value); 
                      setAviso({...aviso,messagem: value});
                      ;}}

                  />
                    
                </div>
                {isAdmin()  && 
                     renderTable()
                    }

                {/* <div className="btnVisualizador">
                    <button className="btn btn-primary" onClick={()=> notificacao()}>Enviar Notificação</button>
                </div> */}
            </div>
        );
    }

    return(
        <Main {...headerProps}>
         {renderForm()}
        </Main>
    );
}